export default __webpack_public_path__ + "static/media/bandMember-Jacob.f3146858.png";